export default {
	sec_10: {
		title: {
			one: 'JP WORLD Pay 자체',
			two: '계좌 시스템',
		},
		desc: {
			one: '은행에만 계좌가 있는 것이 아닙니다.',
			two: 'JP WORLD PAY 제공 계좌로 더욱 편리하게 이용하세요.',
		},
		btn: {
			one: '회원가입하기',
			two: '앱 다운로드',
		},
	},
	sec_13: {
		title: {
			one: 'JP WORLD PAY 계좌 시스템으로',
			two: '빠른 송금 ',
			three: '지금 사용해보세요.',
		},
		features: {
			one: {
				title: {
					one: '자체 계좌 시스템으로',
					two: '더욱 빠르게',
				},
				description: {
					one: 'JP WORLD PAY에서 JP WORLD PAY 계좌로 송금시',
					two: '1~3초 안에 송금이 가능하게 되었습니다. 이제는 기다리지 마세요.',
				},
			},
			two: {
				title: {
					one: '송금 시스템을',
					two: '만들다',
				},
				description: {
					one: '계좌를 이용한 JP WORLD PAY에서 JP WORLD PAY로 송금시',
					two: '수수료 무료, 시간 절약까지',
				},
			},
		},
	},
};
